import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { LogoMark } from "./Logo";
import { NAV } from "../data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <>
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${
        scrolled ? "bg-[rgba(244,244,241,0.78)] backdrop-blur-xl shadow-[0_1px_0_var(--line)] py-3" : "py-5 sm:py-6"
      }`}
      data-testid="site-header"
    >
      <div className="container-x flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 text-[var(--ink)]" data-testid="header-logo-link" aria-label="1818 Brands home">
          <LogoMark className={`w-auto transition-[height] duration-500 ${scrolled ? "h-9" : "h-11 lg:h-12"}`} />
        </Link>
        <nav className="hidden md:flex items-center gap-10" aria-label="Main">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end
              className={({ isActive }) => `link-underline pb-1 text-[14px] font-normal tracking-[0.01em] ${isActive ? "active" : "text-[var(--ink-soft)] hover:text-[var(--ink)]"}`}
              data-testid={`nav-${n.label.toLowerCase()}-link`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <button
          className="md:hidden relative h-10 w-10 flex flex-col items-center justify-center gap-[6px]"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          <span className={`block h-px w-7 bg-[var(--ink)] transition-transform duration-500 ${open ? "translate-y-[3.5px] rotate-45" : ""}`} />
          <span className={`block h-px w-7 bg-[var(--ink)] transition-transform duration-500 ${open ? "-translate-y-[3.5px] -rotate-45" : ""}`} />
        </button>
      </div>
    </header>
      <AnimatePresence>
        {open && (
          <motion.nav
            className="md:hidden fixed inset-0 z-40 bg-[var(--paper)] px-6 pt-28"
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            animate={{ clipPath: "inset(0 0 0% 0)" }}
            exit={{ clipPath: "inset(0 0 100% 0)" }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            data-testid="mobile-menu"
          >
            {NAV.map((n, i) => (
              <motion.div key={n.to} initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.15 + i * 0.06, duration: 0.6 }}>
                <NavLink
                  to={n.to}
                  end
                  className="flex items-baseline justify-between border-b border-[var(--line)] py-5 font-serif-display text-[2rem]"
                  data-testid={`mobile-nav-${n.label.toLowerCase()}-link`}
                >
                  {n.label}
                  <span className="text-xs tracking-[0.2em] text-[var(--ink-soft)]">0{i + 1}</span>
                </NavLink>
              </motion.div>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </>
  );
};
